import React, { useState } from 'react';
import axios from 'axios';
import { apiPath } from './api';
import './DemoModeBar.css';

/**
 * After market close — load dummy stocks to test BUY / HOLD / SELL UI.
 * @param {'normal' | 'twohour'} mode
 */
export default function DemoModeBar({ mode = 'normal', demoMode, marketClosed, alwaysShow, onChange }) {
  const [busy, setBusy] = useState(false);
  const apiBase = mode === 'twohour' ? '/api/twohour/demo' : '/api/normal/demo';
  const showBar = alwaysShow || demoMode || marketClosed;

  if (!showBar) return null;

  const toggle = async (enable) => {
    setBusy(true);
    try {
      await axios.post(apiPath(apiBase), { enable });
      onChange?.();
    } catch (e) {
      console.error('Demo mode toggle failed', e);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={`demo-mode-bar ${demoMode ? 'active' : ''}`} role="region" aria-label="Demo testing mode">
      <div className="demo-mode-text">
        {demoMode ? (
          <>
            <strong>DEMO MODE</strong>
            <span>Dummy stocks &amp; live prices — test all buttons · your real records stay safe</span>
          </>
        ) : (
          <>
            <strong>Market closed?</strong>
            <span>Load demo data to test BUY · HOLD · SELL — original trading records are not deleted</span>
          </>
        )}
      </div>
      <div className="demo-mode-actions">
        {!demoMode ? (
          <button type="button" className="demo-mode-btn on" disabled={busy} onClick={() => toggle(true)}>
            {busy ? 'Loading…' : 'Load demo data'}
          </button>
        ) : (
          <button type="button" className="demo-mode-btn off" disabled={busy} onClick={() => toggle(false)}>
            {busy ? '…' : 'Exit demo'}
          </button>
        )}
      </div>
    </div>
  );
}
